import { fg } from '@atlaskit/platform-feature-flags';

import { DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI } from '../../../types/default-cloud-graph-conversation-entity-ati';
import { DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI } from '../../../types/default-cloud-graph-message-entity-ati';
import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI } from '../../../types/default-cloud-graph-video-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import {
	type TypeFilterValue3PEntities,
	TypeFilterValueKey,
} from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { TeamsIcon, TeamsIconBorderless, TeamsSearchResultIcon } from './icon';

const getTeamsTypeFilterConfig = () => {
	const config = new Map<TypeFilterValueKey, TypeFilterValue3PEntities>();

	config.set(TypeFilterValueKey.Conversation, {
		entities3P: [
			...DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI,
			...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
		],
		subTypes3P: [],
	});

	config.set(TypeFilterValueKey.Message, {
		entities3P: DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI,
		subTypes3P: [],
	});

	config.set(TypeFilterValueKey.Video, {
		entities3P: DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI,
		subTypes3P: [],
	});

	if (fg('rovo_fps_enable_ms_teams_attachment_type_filter')) {
		// NOTE: Attachment intentionally reuses DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI (same as
		// Message above) because there is no dedicated attachment ATI in the cloud graph schema.
		// This means convertFiltersToQueryParams / extractType cannot distinguish 'attachment'
		// from 'message' when reading back the blob — both produce ati:cloud:graph:message with
		// no differentiating subtypes.
		// To fix this properly, either:
		//   1. Introduce a dedicated ati:cloud:graph:attachment entity ATI, or
		//   2. Add a NounSubtypeKey.Attachment subtype and update the Teams config to use it.
		config.set(TypeFilterValueKey.Attachment, {
			entities3P: DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI,
			subTypes3P: [],
		});
	}

	return config;
};

export const teamsConfig: ThirdPartyConfig = {
	displayName: 'Microsoft Teams',
	id: 'teams',
	resourceType: ProductResourceTypes3P.Teams,
	icon: get3PLogo(TeamsIcon, 'Teams', 'medium'),
	iconBorderless: get3PLogo(TeamsIconBorderless, 'Teams', 'small'),
	searchResultIcon: get3PLogo(TeamsSearchResultIcon, 'Teams', 'large'),
	integrationAri: 'ari:cloud:platform::integration/microsoft',
	get typeFilterConfig() {
		return getTeamsTypeFilterConfig();
	},
	filters: ['lastUpdated', 'hasAttachment'],
	requiresOauth: true,
	isEnabled: () => true,
};
